import { Epic, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { Action } from '../../actions';
import {
    UpdateImportExportWizardLock,
    updateImportExportWizardLockAction
} from '../../actions/importExportWizard/updateImportExportWizardLock';
import { SAVE_IMPORT_WIZARD_FILE, SaveImportWizardFile } from '../../actions/importWizard/saveImportWizardFile';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';

type EpicActions = UpdateImportExportWizardLock;

export const saveImportSourceFilesEpic: Epic<Action, Action, State, EpicDeps> = action$ => {
    return action$.pipe(
        ofType(SAVE_IMPORT_WIZARD_FILE),
        switchMap(
            (action: SaveImportWizardFile): Observable<EpicActions> => {
                const { file } = action;

                return of(updateImportExportWizardLockAction(file === null));
            }
        )
    );
};
